import React from 'react'
import { MdDeleteForever } from "react-icons/md";
import { FiPaperclip, FiClock, FiBookOpen } from 'react-icons/fi'

const Card = ({showDeleteButton, onChange, cardDraggable, editable, onDelete, onClick, style, tagStyle, className, id, title, duration, description, tags}: any) => {
  return (
    <div
      data-id={id}
      onClick={onClick}
      style={{...style, cursor: cardDraggable ? 'grab' : 'auto'}}
      className={`${className} mb-3 shadow-lg rounded !cursor-pointer p-2 border-l-lime-500 border-l-4 bg-white hover:bg-gray-100`}
    >
      <div className='flex max-w-xs h-20 items-center'>
        <div>
          <FiBookOpen className="bg-lime-500 rounded-full h-8 w-8 p-2" color="white" />
        </div>
        <div className='flex-1 ml-2 flex flex-col h-full'>
          <h6 className='text-gray-500'>
            {title}
          </h6>
          <div className='text-xs text-gray-400 whitespace-normal overflow-scroll flex-1'>
            {description}
          </div>
        </div>
        {
          showDeleteButton && <div>
            <MdDeleteForever className='ml-2 text-red-500' onClick={onDelete} />
          </div>
        }
      </div>
      <div className='text-gray-400 flex justify-between'>
        {/*<div className='flex items-center'><FiPaperclip className='mr-1' /> 5</div>
        */}
        <div className='flex items-center'><FiClock className='mr-1' /> {duration} <small className='self-end ml-1'>min</small></div>
      </div>
    </div>
  )
  
}
export default Card
